module.exports = __webpack_public_path__ + "img/power-pro-select.5044a7dc.svg";